import React, { useState, useRef, useEffect } from "react";

import { useIsMobile } from "../utils/useIsMobile";
import ForgotPasswordModal from "./ForgotPasswordModal";


const AuthPanel = ({
  email,
  password,
  setEmail,
  setPassword,
  authMode,
  setAuthMode,
  onSignin,
  onSignup,
  onGoogleAuth,
  condition,
  setCondition
}) => {


  const isSignup = authMode === "signup";
  const [formTouched, setFormTouched] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const emailInputRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormTouched(true);

    if (!isValid()) return;

    isSignup ? onSignup() : onSignin();
  };

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
  
      if (isMobile) {
        setTimeout(() => {
          emailInputRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300); // slight delay to wait for modal rendering
      }
    }
    // eslint-disable-next-line
  }, []);

  const isValid = () => {
    if (!email || !isEmailValid(email)) return false;
    if (!password) return false;
    if (isSignup && !condition) return false;
    return true;
  };

  const isEmailValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const isMobile = useIsMobile();

  return (
    <div
      style={{
        marginTop: "2rem",
        border: "1px solid #ccc",
        padding: "1.5rem",
        borderRadius: "8px",
        maxWidth: "400px",
        marginLeft: "auto",
        marginRight: "auto",
        backgroundColor: "#fafafa"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          marginBottom: "1rem",
          gap: "0.5rem",
          // flexDirection: window.innerWidth < 315 ? "column" : "row" // ✅ Responsive layout
          flexDirection: isMobile ? "column" : "row" // ✅ Responsive layout
        }}
      >
        <button
          onClick={() => setAuthMode("signin")}
          style={{
            flex: 1,
            padding: "0.75rem",
            backgroundColor: authMode === "signin" ? "#e6f0ff" : "transparent",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontWeight: authMode === "signin" ? "bold" : "normal",
            color: "#333",
            cursor: "pointer",
            fontSize: authMode === "signin" ? "1.2rem" : "1rem", // for Sign In
          }}
        >
          🔓 Sign In
        </button>
        <button
          onClick={() => setAuthMode("signup")}
          style={{
            flex: 1,
            padding: "0.75rem",
            backgroundColor: authMode === "signup" ? "#e6f0ff" : "transparent",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontWeight: authMode === "signup" ? "bold" : "normal",
            color: "#333",
            cursor: "pointer",
            fontSize: authMode === "signin" ? "1.2rem" : "1rem", // for Sign In
          }}
        >
          🆕 Sign Up
        </button>
      </div>


      <div style={{ transition: "opacity 0.3s ease" }}>
        <form onSubmit={handleSubmit}>
          {isSignup && (
            <>
              <label style={{ marginBottom: "0.25rem" }}>Select your condition:</label>
              <select
                value={condition}
                onChange={(e) => setCondition(e.target.value)}
                style={{ width: "100%", marginBottom: "1rem" }}
              >
                <option value="Type 1 diabetes">Type 1 diabetes</option>
                <option value="Type 2 diabetes">Type 2 diabetes</option>
                <option value="Pre-diabetes">Pre-diabetes</option>
                <option value="Gestational diabetes">Gestational diabetes</option>
              </select>
            </>
          )}

          <input
            ref={emailInputRef}
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            required
            style={{
              width: "100%",
              marginBottom: "0.5rem",
              borderColor: formTouched && (!email || !isEmailValid(email)) ? "red" : "#ccc"
            }}
          />
          {formTouched && !email && (
            <p style={{ color: "red", fontSize: "0.85rem" }}>Email is required</p>
          )}

          {formTouched && email && !isEmailValid(email) && (
            <p style={{ color: "red", fontSize: "0.85rem" }}>Invalid email format</p>
          )}

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
            style={{ width: "100%", marginBottom: "1rem" }}
          />
          {formTouched && !password && <p style={{ color: "red", fontSize: "0.85rem" }}>Password is required</p>}


          {isSignup ? (
            // Signup — show only full-width Sign Up button
            <button
              type="submit"
              disabled={!isValid()}
              style={{
                width: "100%",
                marginBottom: "0.5rem",
                opacity: isValid() ? 1 : 0.6,
                cursor: isValid() ? "pointer" : "not-allowed"
              }}
            >
              Sign Up with Email
            </button>
          ) : (
            // Sign-in — show Sign In + Forgot Password side-by-side
            <div style={{ display: "flex", gap: "0.5rem", marginBottom: "0.5rem" }}>
              <button
                type="submit"
                disabled={!isValid()}
                style={{
                  flex: 2,
                  padding: "0.5rem",
                  opacity: isValid() ? 1 : 0.6,
                  cursor: isValid() ? "pointer" : "not-allowed"
                }}
              >
                Sign In with Email
              </button>
              <button
                type="button"
                onClick={() => setShowForgotModal(true)}
                style={{
                  flex: 1,
                  padding: "0.5rem",
                  fontSize: "0.85rem",
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #ccc",
                  cursor: "pointer"
                }}
              >
                Forgot Password
              </button>
            </div>
          )}

          {isSignup && formTouched && !condition && <p style={{ color: "red", fontSize: "0.85rem" }}>Please select a condition</p>}


        </form>

        <ForgotPasswordModal
          open={showForgotModal}
          onClose={() => setShowForgotModal(false)}
          initialEmail={email}
        />
      </div>

      <div style={{ textAlign: "center", margin: "0.5rem 0" }}>
        <small>or</small>
      </div>

      <button
        onClick={onGoogleAuth}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
          padding: "0.5rem",
          border: "1px solid #ccc",
          borderRadius: "6px",
          backgroundColor: "#fff",
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/google-logo.svg`}
          alt="Google"
          style={{ width: "1.2rem", height: "1.2rem" }}
        />
        {isSignup ? "Sign up with Google" : "Sign in with Google"}
      </button>
    </div>
  );
};

export default AuthPanel;
